import { Clickable } from '@carvana/vdp-components';
import { useContext } from 'react';
import type React from 'react';
import ModalContext from '~/contexts/ModalContext';
import SavedSearchesContext from '~/contexts/SavedSearchesContext';

export default function ManageAlerts() {
  const { savedSearches } = useContext(SavedSearchesContext);
  const { setManageSavedSearchesOpen } = useContext(ModalContext);

  const show = savedSearches.length > 0;

  const handleClick: React.MouseEventHandler<HTMLAnchorElement> = e => {
    e.preventDefault();
    setManageSavedSearchesOpen(true);
  };

  return (
    <Clickable
      element="span"
      className="font-normal text-blue-2 underline"
      href="#"
      onClick={handleClick}
      data-analytics-id="Manage Alerts"
    >
      <span className={show ? 'inline' : 'hidden'}>
        ({savedSearches.length}
        <span className="hidden m:inline"> Saved</span>)
      </span>
    </Clickable>
  );
}
